import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  inject,
  effect,
  signal,
  computed,
  OnDestroy,
} from '@angular/core';
import { FeatureFlags } from '@uigy/shared/enums/feature-flags.enum';
import { FeatureFlagService } from '@uigy/shared/services/feature-flag.service';

@Directive({
  selector: '[appFeatureFlag]',
  standalone: true
})
export class FeatureFlagDirective implements OnDestroy {
  private templateRef = inject(TemplateRef<any>);
  private viewContainer = inject(ViewContainerRef);
  private featureFlagService = inject(FeatureFlagService);

  @Input() set appFeatureFlag(flagName: FeatureFlags) {
    this.flagName.set(flagName);
  }

  private flagName = signal<FeatureFlags>('' as FeatureFlags);
  private shouldShow = computed(() => {
    return this.featureFlagService.getFlag(this.flagName());
  });

  constructor() {
    effect(() => {
      this.updateView(this.shouldShow());
    });
  }

  private updateView(show: boolean): void {
    if (show) {
      if (this.viewContainer.length === 0) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      }
    } else {
      this.viewContainer.clear();
    }
  }

  public ngOnDestroy(): void {
    this.viewContainer.clear();
  }
}
